"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemIcon = exports.MenuItemDetail = exports.MenuItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _common = require("../styles/common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MenuItemIcon = _styledComponents.default.div`
    margin-right: 10px;

    > i {
        display: block;
    }
`;
exports.MenuItemIcon = MenuItemIcon;
MenuItemIcon.displayName = 'MenuItemIcon';
const StyledMenuItem = (0, _styledComponents.default)(_MenuItem.default)`
    color: var(--text-primary-color);
    font-size: 14px;
    height: 38px;

    ${_common.hoverListItem}
    &:focus-visible {
        background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
    }

    &.Mui-focusVisible {
        background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
    }

    &.Mui-selected {
        ${_common.selectedListItem}
        &:hover {
            ${_common.selectedListItem}
        }
        &:focus-visible {
            background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
        }
    }
`;
const Component = props => {
  return /*#__PURE__*/_react.default.createElement(StyledMenuItem, _extends({
    disableRipple: true
  }, props));
};
exports.MenuItem = Component;
Component.propTypes = _MenuItem.default.propTypes;
const MenuItemDetail = (0, _styledComponents.default)(_MenuItem.default)`
    color: var(--text-primary-color);
    font-size: 14px;

    display: flex;
    align-items: flex-start;
    ${_common.hoverListItem}

    &.Mui-focusVisible {
        background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
    }

    &.Mui-selected {
        ${_common.selectedListItem}
        &:hover {
            ${_common.selectedListItem}
        }
        &:focus-visible {
            background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
        }
    }
`;
exports.MenuItemDetail = MenuItemDetail;
MenuItemDetail.defaultProps = _objectSpread({
  disableRipple: true
}, MenuItemDetail.defaultProps);
MenuItemDetail.displayName = 'MenuItemDetail';
MenuItemDetail.Content = _styledComponents.default.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
`;
MenuItemDetail.Content.displayName = 'MenuItemDetail.Content';
MenuItemDetail.Title = _styledComponents.default.div`
    font-size: 14px;
    font-weight: bold;
    line-height: 32px;
    ${_common.textOverflow};
`;
MenuItemDetail.Title.displayName = 'MenuItemDetail.Title';
MenuItemDetail.Info = _styledComponents.default.div`
    ${_common.textSecondary};
    white-space: normal;
    transition: color 0.25s ease-in;

    ${MenuItemDetail}:hover & {
        color: var(--vcs-color--primary);
    }

    ${MenuItemDetail}.Mui-selected & {
        color: var(--vcs-color--primary);
    }
`;
MenuItemDetail.Info.displayName = 'MenuItemDetail.Info';